import {
  ResourcePairField,
  ResourcePairFieldProps,
} from './_components/ResourcePairField';

export const RecommendationPercentileField = ({
  LabelComponent,
}: Pick<ResourcePairFieldProps, 'LabelComponent'>) => {
  return (
    <ResourcePairField
      LabelComponent={LabelComponent}
      size="medium"
      variant="percentile"
      testId="recommendation-percentile-field"
    />
  );
};
